import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import ComponentLoader from "../../layout/ComponentLoader";
import { t } from "i18next";
import ModalDetailSpace from "./ModalDetailSpace";
import { Form } from "react-bootstrap";

//https://github.com/namespace-ee/react-calendar-timeline/tree/master/examples

const ComponentCalendrierGlobal = (props) => {
  const { calendriers, sallesAvecEmail, debutCalendrier, finCalendrier, usagesDiponibles } = props;
  const [dateDebutCalendrierModule, setDateDebutCalendrierModule] = useState(new Date());
  const [dateJour, setDateJour] = useState();
  const [visibleTimeStart, setVisibleTimeStart] = useState();
  const [visibleTimeEnd, setVisibleTimeEnd] = useState();
  const [salles, setSalles] = useState([]);
  const [rdvs, setRdvs] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [sallePopup, setSallePopup] = useState();
  const [calendrierPopup, setCalendrierPopup] = useState();

  const handleShowDetails = (salle, calendrier) => {
    setSallePopup(salle);
    setCalendrierPopup(calendrier);
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };

  useEffect(() => {
    // preparation de la date de debut de journée (7h)
    let DebutJournee = new Date(dateDebutCalendrierModule);
    DebutJournee.setHours(8);
    DebutJournee.setMinutes(0);
    DebutJournee.setSeconds(0);
    DebutJournee = new Date(DebutJournee).valueOf();
    setVisibleTimeStart(DebutJournee);

    // preparation de la date de fin de  journée (20h)
    let FinJournee = new Date(dateDebutCalendrierModule);
    FinJournee.setHours(20);
    FinJournee.setMinutes(0);
    FinJournee.setSeconds(0);
    FinJournee = new Date(FinJournee).valueOf();
    setVisibleTimeEnd(FinJournee);

    // affichage de la date du jour
    const date = new Date(dateDebutCalendrierModule);
    const jour = date.getDate().toString().padStart(2, "0");
    const mois = (date.getMonth() + 1).toString().padStart(2, "0");
    const annee = date.getFullYear();
    setDateJour(annee + "-" + mois + "-" + jour);

    /* on va préparer les salles pour les afficher à gauche du calendrier */
    let sallesTemp = [];
    let rdvsTemp = [];
    let idUnique = 1;
    let ajoutFuseauHoraire = -date.getTimezoneOffset() / 60;

    calendriers.forEach((calendrier) => {
      let sallesMatch = sallesAvecEmail.filter((item) => item.email === calendrier.salleAdress);
      if (sallesMatch.length) {
        let nomSalle = sallesMatch[0].nom;
        sallesTemp.push({ id: calendrier.salleAdress, title: nomSalle });
        Object.keys(calendrier.agendaSalle).map((jour, indexJour) => {
          let lesRdvs = calendrier.agendaSalle[jour];
          lesRdvs.map((rdv, indexRdv) => {
            let isoDateStart = new Date(rdv.dateDebut);
            let isoDateEnd = new Date(rdv.dateFin);
            isoDateStart.setHours(isoDateStart.getHours() + ajoutFuseauHoraire);
            isoDateEnd.setHours(isoDateEnd.getHours() + ajoutFuseauHoraire);
            isoDateStart = new Date(isoDateStart).valueOf();
            isoDateEnd = new Date(isoDateEnd).valueOf();
            rdvsTemp.push({
              id: idUnique,
              group: calendrier.salleAdress,
              title: rdv.sujet,
              start_time: isoDateStart,
              end_time: isoDateEnd,
            });
            idUnique++;
          });
        });
      }
    });

    setSalles(sallesTemp);
    setRdvs(rdvsTemp);
  }, [dateDebutCalendrierModule, calendriers, sallesAvecEmail]); // eslint-disable-line react-hooks/exhaustive-deps

  const BarreRdv = (objet) => {
    const leRDV = objet.props;
    if (visibleTimeStart <= leRDV.start_time && visibleTimeEnd >= leRDV.end_time) {
      let depart = ((leRDV.start_time - visibleTimeStart) / 1000 / 60 / 60) * 50;
      let longueur = ((leRDV.end_time - leRDV.start_time) / 1000 / 60 / 60) * 50;

      return (
        <div className="barreRDV" style={{ left: depart + "px", width: longueur + "px" }}>
          {/* {leRDV.title} */}
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {calendriers.length === 0 && (
        <div className="text-center">
          <ComponentLoader />
        </div>
      )}
      {calendriers.length > 0 && (
        <div>
          <ModalDetailSpace
            espace={sallePopup}
            show={showDetails}
            handleClose={handleCloseDetails}
            calendrier={calendrierPopup}
            usagesDisponibles={usagesDiponibles}
          />
          <div className="contentTableCalendrier">
            <Table striped bordered hover className="calendrier">
              <thead className="enteteDates">
                <tr>
                  <th className="colonneSticky">
                    <span>
                      <Form.Control
                        type="date"
                        min={debutCalendrier}
                        max={finCalendrier}
                        value={dateJour}
                        onChange={(e) => setDateDebutCalendrierModule(e.target.value)}
                      />
                    </span>
                  </th>
                  <th>8h</th>
                  <th>9h</th>
                  <th>10h</th>
                  <th>11h</th>
                  <th>12h</th>
                  <th>13h</th>
                  <th>14h</th>
                  <th>15h</th>
                  <th>16h</th>
                  <th>17h</th>
                  <th>18h</th>
                  <th>19h</th>
                </tr>
              </thead>
              <tbody>
                {salles.length === 0 && (
                  <tr>
                    <td colSpan="12" className="text-center">
                      {t("public.pageTierslieux.aucuneSalle")}
                    </td>
                  </tr>
                )}
                {salles.map((salle, index) => (
                  <tr key={index}>
                    <td className="salle colonneSticky">
                      <div
                        role="button"
                        onClick={() => {
                          handleShowDetails(
                            sallesAvecEmail.filter((item) => item.email === salle.id)[0],
                            calendriers.filter((item) => item.salleAdress === salle.id)[0]
                              .agendaSalle
                          );
                        }}
                      >
                        {salle.title}
                      </div>
                    </td>
                    <td className="position-relative horaire">
                      {rdvs
                        .filter((item) => item.group === salle.id)
                        .map((rdv, index) => (
                          <BarreRdv props={rdv} key={index} />
                        ))}
                    </td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                    <td className="horaire"></td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="enteteDates">
                <tr>
                  <th className="colonneSticky">
                    <span>
                      <Form.Control
                        type="date"
                        min={debutCalendrier}
                        max={finCalendrier}
                        value={dateJour}
                        onChange={(e) => setDateDebutCalendrierModule(e.target.value)}
                      />
                    </span>
                  </th>
                  <th>8h</th>
                  <th>9h</th>
                  <th>10h</th>
                  <th>11h</th>
                  <th>12h</th>
                  <th>13h</th>
                  <th>14h</th>
                  <th>15h</th>
                  <th>16h</th>
                  <th>17h</th>
                  <th>18h</th>
                  <th>19h</th>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      )}
    </>
  );
};

export default ComponentCalendrierGlobal;
